import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { resetFormEvent } from '../../../actions/components/form';
import { fetchReservationAvailableEvent } from '../../../sagas/routines';

const initialState = {
  defaultEvent: null,
  fetchingEvent: false,
  fetchedEvent: false,
  fetchEventError: null
};

const fetchEventHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    fetchingEvent: true,
    fetchedEvent: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('defaultEvent', response, state),
  [routine.FAILURE]: (state, { payload: error }) =>
    set('fetchEventError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetchingEvent: false,
    fetchedEvent: true
  })
});

const resetEventHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchEventHandler(fetchReservationAvailableEvent),
  ...resetEventHandler(resetFormEvent)
});
